import axios from 'axios';
import { getApiBaseUrl } from '../utils/env';

const fetchKeywordsSuccess = keywords => ({
  type: 'FETCH_KEYWORDS_SUCCESS',
  payload: keywords,
});

const updateBusyIndicator = val => ({
  type: 'KEYWORD_REQUEST_ON_PROGRESS',
  payload: val,
});

export const apiKeywordProvider =
  ({ publisher, ...params }) =>
  async dispatch => {
    try {
      dispatch(updateBusyIndicator(true));
      let { data } = await axios.get(`${getApiBaseUrl()}/${publisher}/keyword-match/image`, {
        params,
      });
      dispatch(fetchKeywordsSuccess(data));
      dispatch(updateBusyIndicator(false));
    } catch (e) {
      updateBusyIndicator(false);
      console.error(e);
    }
  };

export interface EngageState {
  keywords: Record<string, any> | null;
  paginationPerPage: number;
  paginationPage: number;
  filterDateRange: string;
  filterArticleType: string;
  filterHasRanked: boolean;
  busy: boolean;
  pagination: {
    currentPage: number;
    itemCount: number;
    itemsPerPage: number;
    totalItems: number;
    totalPages: number;
  };
}

const initialState: EngageState = {
  keywords: null,
  paginationPerPage: 20,
  paginationPage: 0,
  filterDateRange: '1day',
  filterArticleType: 'image-only',
  filterHasRanked: true,
  busy: false,
  pagination: {
    currentPage: 1,
    itemCount: 0,
    itemsPerPage: 50,
    totalItems: 0,
    totalPages: 0,
  },
};

const keywordReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PAGINATION': {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      };
    }
    case 'FETCH_KEYWORDS_SUCCESS':
      let { items, meta: pagination } = action.payload;
      return {
        ...state,
        keywords: items,
        pagination,
      };
    case 'SET_FILTER_ARTICLES':
      return {
        ...state,
        filterDateRange: action.payload.filterDateRange,
        filterHasRanked: action.payload.filterHasRanked,
        filterArticleType: action.payload.filterArticleType,
        pagination: {
          ...state.pagination,
          currentPage: 1,
        },
      };
    case 'KEYWORD_REQUEST_ON_PROGRESS': {
      return {
        ...state,
        busy: action.payload,
      };
    }
    default:
      return state;
  }
};

export default keywordReducer;
